import xhr from 'xhr'

export default async function getStudentObserver(data) {
  const res = await xhr(
    `/student-observers?filters[student][id][$eq]=${data.id}&sort[0]=id:desc&populate=from_teacher.user`
  )

  return res.data.data
}
